export default "__VITE_ASSET__CSgkMcp8__"